import filterList from '@shared/lib/general/filterList';
import _ from 'lodash';

import initialState from './orderInitialState';
import mutations from './orderMutation';
import actions from './orderAction';

const orderGetters = {
  orderFilters: (state) => {
    const {
      orderFilters,
    } = state;

    const copy = _.cloneDeep(orderFilters);
    return copy;
  },
  orderTableHeaders: (state, getters) => {
    const {
      activeTab,
      sharedHeaders,
      customerOrderTableHeaders,
      partnerOrderTableHeaders,
    } = state;
    const {
      isSmacAdmin,
    } = getters;
    let tableHeaders = [
      ...sharedHeaders,
      ...customerOrderTableHeaders,
    ];

    if (isSmacAdmin) {
      tableHeaders.push({
        text: 'Requested By',
        align: 'start',
        sortable: true,
        filterable: true,
        value: 'requestorId',
      });
    }
    if (activeTab === 'partner') {
      tableHeaders = [
        ...sharedHeaders,
        ...partnerOrderTableHeaders,
      ];
    }
    return tableHeaders;
  },
  orderTableData: (state) => {
    const {
      customerOrders,
      partnerOrders,
      activeTab,
      activeOrderStatus,
      orderRange,
    } = state;
    let tableData = customerOrders;
    if (activeTab === 'partner') {
      tableData = partnerOrders;
    }

    let updatedOrders = tableData.map((o, index) => {
      let name;
      if (activeTab === 'partner') {
        name = o.name;
      } else {
        name = `${o.customer.firstName} ${o.customer.lastName}`;
      }
      const nCustomer = {
        ...o.customer,
        name,
      };
      let total = 0;
      let count = 0;
      let openCounter = 0;
      let cancelledCounter = 0;
      let holdCounter = 0;
      let error = false;
      let status = '';
      let shipDate = null;
      let deliveryDate = null;
      let shippingOption = null;
      let trackingNumber = null;
      const orderLineKey = activeTab === 'partner' ? 'orderLines' : 'orderLine';
      if (o[orderLineKey]) {
        o[orderLineKey].forEach((oL) => {
          const {
            status: sT,
            shippingOption: sO,
            shipDate: sD,
            deliveryDate: dD,
            trackingNumber: tN,
            sku,
          } = oL;
          if (sT !== 'Ignore' && !sku?.includes('SHIPPING') && !sku?.includes('SMAC10PM') && !sku?.includes('SMAC9PM')) {
            total += 1;
          }
          if (sT === 'Error') {
            error = true;
          } else if (sT === 'Shipped' || sT === 'Delivered' || sT === 'Returned') {
            count += 1;
          } else if (sT === 'Open') {
            openCounter += 1;
          } else if (sT === 'Do not ship' || sT === 'Cancelled') {
            cancelledCounter += 1;
          } else if (sT === 'Waiting for review') {
            holdCounter += 1;
          }
          if (sO) {
            shippingOption = sO;
          }
          if (sD) {
            shipDate = sD;
          }
          if (dD) {
            deliveryDate = dD;
          }
          if (tN) {
            trackingNumber = tN;
          }
        });
      }
      if (error) {
        status = 'Error';
      } else if (openCounter === total) {
        status = 'No items shipped';
      } else if (cancelledCounter === total) {
        status = 'Cancelled';
      } else if (holdCounter === total) {
        status = 'Review';
      } else if (count === 0) {
        status = 'Pending fulfillment';
      } else if (count < total) {
        status = 'Partially shipped';
      } else if (count === total) {
        status = 'All items shipped';
      }

      return {
        ...o,
        status,
        shippingOption,
        shipDate,
        deliveryDate,
        trackingNumber,
        customer: nCustomer,
        expanded: false,
        selected: false,
        index,
      };
    });
    if (activeOrderStatus) {
      updatedOrders = updatedOrders.filter((a) => a.status === activeOrderStatus);
    }
    if (orderRange) {
      if (orderRange.start && orderRange.end) {
        updatedOrders = filterList(orderRange, tableData, 'orderRange');
      }
    }
    return updatedOrders;
  },
  orderTableRecordCount: (state, getters) => {
    const {
      orderTableOptions: {
        itemsPerPage,
      },
    } = state;
    const {
      orderTableData,
    } = getters;
    if (orderTableData.length === 0) {
      return 0;
    }
    return Math.ceil(orderTableData.length / itemsPerPage);
  },
  subTotal(state) {
    const {
      newOrder,
    } = state;
    let subTotal = 0;
    newOrder.orderItems.forEach((oi) => {
      const {
        price,
        quantity,
        discount,
      } = oi;
      let itemTotal = price * quantity;
      if (discount?.discountAmount) {
        itemTotal -= discount.discountAmount;
      }
      if (discount?.discountPercent) {
        itemTotal -= itemTotal * (discount?.discountPercent / 100);
      }
      subTotal += itemTotal;
    });
    return subTotal;
  },
  taxTotal(state, getters) {
    const {
      newOrder,
    } = state;
    const {
      subTotal,
    } = getters;
    if (!newOrder.tax || !newOrder.chargeMember) {
      return 0;
    }
    const percent = newOrder.tax.percentage / 100;
    return Math.round((subTotal * percent) * 100) / 100;
  },
  shippingTotal(state) {
    const {
      newOrder,
    } = state;
    if (!newOrder?.shippingTotal) {
      return 0;
    }
    return newOrder?.shippingTotal;
  },
  netTotal(state, getters) {
    const {
      newOrder,
    } = state;
    const {
      subTotal,
      taxTotal,
      shippingTotal,
    } = getters;
    if (!newOrder.chargeMember) {
      return 0;
    }
    return (subTotal + taxTotal) - shippingTotal;
  },
};

const orderModule = {
  state: initialState(),
  mutations,
  actions,
  getters: orderGetters,
};

export default orderModule;
